import React, { memo } from 'react';
import cc from 'classcat';
import ToggleButton from '../ToggleButton/ToggleButton';
import RoundButton from '../RoundButton/RoundButton';
import { GroupFilterValues } from '../../store/appGlobalData/types';
/**
 * A component that shows a specific button, based on a boolean value
 *
 * @showToggle: boolean determines which button to show
 */
var FilterButtons = function (props) {
    var id = props.id, showToggle = props.showToggle, theme = props.theme, className = props.className, currentSwitchValue = props.currentSwitchValue, onSwitch = props.onSwitch, onRoundBtnClicked = props.onRoundBtnClicked;
    var switchValues = [GroupFilterValues.politikes, GroupFilterValues.athlitikes];
    return (React.createElement(React.Fragment, null, showToggle
        ? (React.createElement(ToggleButton, { className: cc([className]), id: id, leftLabel: "\u03B1\u03B8\u03BB\u03B7\u03C4\u03B9\u03BA\u03B1", rightLabel: "\u03C0\u03BF\u03BB\u03B9\u03C4\u03B9\u03BA\u03B1", checked: currentSwitchValue === switchValues[0], onSwitch: function () { return onSwitch(currentSwitchValue === switchValues[0] ? switchValues[1] : switchValues[0]); } }))
        : (React.createElement(RoundButton, { className: cc([className]), theme: theme, label: "\u03BF\u03BB\u03B1 \u03C4\u03B1 \u03C0\u03C1\u03C9\u03C4\u03BF\u03C3\u03B5\u03BB\u03B9\u03B4\u03B1", onClick: onRoundBtnClicked }))));
};
FilterButtons.defaultProps = {
    showToggle: false,
    theme: 'dark',
};
export default memo(FilterButtons);
